import { getAuthHeaders, getBaseUrl } from './apiClient';

export type CourseSupportingDataItem = {
  asset_id: string;
  name: string;
  description: string;
  editor_type: string;
  group: string;
  has_summary: boolean;
};

export type CourseSupportingDataContent = {
  asset_id: string;
  content: string;
  editor_type: string;
  last_modified: string;
  etag: string;
};

export const courseSupportingDataService = {
  async list(): Promise<{ assets: CourseSupportingDataItem[] }> {
    const resp = await fetch(`${getBaseUrl()}/secure/courses/supporting-data`, {
      headers: await getAuthHeaders(),
    });
    if (!resp.ok) throw new Error(`Failed to list supporting data (${resp.status})`);
    return resp.json();
  },

  async get(assetId: string): Promise<CourseSupportingDataContent> {
    const resp = await fetch(
      `${getBaseUrl()}/secure/courses/supporting-data/${encodeURIComponent(assetId)}`,
      { headers: await getAuthHeaders() },
    );
    if (!resp.ok) throw new Error(`Failed to get supporting data (${resp.status})`);
    return resp.json();
  },

  async getSummary(assetId: string): Promise<CourseSupportingDataContent> {
    const resp = await fetch(
      `${getBaseUrl()}/secure/courses/supporting-data/${encodeURIComponent(assetId)}/summary`,
      { headers: await getAuthHeaders() },
    );
    if (!resp.ok) throw new Error(`Failed to get summary (${resp.status})`);
    return resp.json();
  },

  async updateSummary(assetId: string, content: string, etag: string): Promise<{ etag: string }> {
    const headers = await getAuthHeaders();
    const resp = await fetch(
      `${getBaseUrl()}/secure/courses/supporting-data/${encodeURIComponent(assetId)}/summary`,
      {
        method: 'PUT',
        headers: { ...headers, 'If-Match': etag },
        body: JSON.stringify({ content }),
      },
    );
    if (resp.status === 409) {
      throw new Error('This data was modified since you loaded it. Please reload and try again.');
    }
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to update summary: ${resp.status} ${text}`);
    }
    return resp.json();
  },

  async update(assetId: string, content: string, etag: string): Promise<{ etag: string }> {
    const headers = await getAuthHeaders();
    const resp = await fetch(
      `${getBaseUrl()}/secure/courses/supporting-data/${encodeURIComponent(assetId)}`,
      {
        method: 'PUT',
        headers: { ...headers, 'If-Match': etag },
        body: JSON.stringify({ content }),
      },
    );
    if (resp.status === 409) {
      throw new Error('This data was modified since you loaded it. Please reload and try again.');
    }
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to update: ${resp.status} ${text}`);
    }
    return resp.json();
  },
};
